class ProductComparison {
  constructor(dropdowns, productsContainer, rows) {
    this.dropdowns = dropdowns;
    this.productsContainer = productsContainer;
    this.rows = rows;
    this.activeClass = 'active';
    this.comparisons = ['-1', '-1'];
    this.items = [];

    Array.forEach(this.dropdowns, (dropdown) => {
      dropdown.addEventListener('click', this.handleDropdown);

      const items = dropdown.querySelectorAll('li');

      if (items !== null) {
        Array.forEach(items, (item) => {
          item.addEventListener('click', this.handleItemClick);

          this.items.push(item);
        });
      }
    });

    this.render();
  }

  handleDropdown = (e) => {
    e.currentTarget.classList.toggle(this.activeClass);
  }

  handleItemClick = (e) => {
    const selectedProductId = e.currentTarget.getAttribute('data-product-id');

    const index = parseInt(e.currentTarget.getAttribute('data-dropdown-index'), 10);
    this.comparisons[index] = selectedProductId;

    this.render(index);
    this.updateSelected(e.currentTarget.innerHTML, index);
  }

  render = (index) => {
    const products = this.productsContainer.querySelectorAll('div[data-product-id]');

    Array.forEach(products, (product) => {
      const currentProductId = product.getAttribute('data-product-id');
      const comparisonIndex = this.comparisons.indexOf(currentProductId);

      console.log(comparisonIndex, index);
      if (comparisonIndex === index) {
        product.style.order = index;

        if (index === 0) {
          product.style.marginRight = 'auto';
          product.style.marginLeft = '0px';
        } else {
          product.style.marginLeft = 'auto';
          product.style.marginRight = '0px';
        }
      }

      if (comparisonIndex > -1) {
        product.classList.add(this.activeClass);
      } else {
        product.classList.remove(this.activeClass);
        product.style.order = '';
      }
    });

    Array.forEach(this.items, (item) => {
      const id = item.getAttribute('data-product-id');

      if (id === '-1') {
        item.style.display = 'block';
      } else if (this.comparisons.indexOf(id) > -1) {
        item.style.display = 'none';
      } else {
        item.style.display = 'block';
      }
    });

    // Remove this for now...
    // if (this.comparisons.every(x => x === '-1')) {
    //   Array.forEach(this.rows, (row) => {
    //     row.classList.add('mobile-hidden');
    //   });
    // } else {
    //   Array.forEach(this.rows, (row) => {
    //     row.classList.remove('mobile-hidden');
    //   });
    // }
  }

  updateSelected = (html, index) => {
    Array.forEach(this.dropdowns, (dropdown, dropdownIndex) => {
      if (index === dropdownIndex) {
        this.placeholder = dropdown.querySelector('.js-selected-item');

        this.placeholder.innerHTML = html;
      }
    });
  }
}

const dropdowns = document.querySelectorAll('.js-comparison-dropdown');
const products = document.querySelector('.js-products-container');
const rows = document.querySelectorAll('.js-attribute-row');

if (dropdowns !== null && products !== null) {
  // eslint-disable-next-line
  new ProductComparison(dropdowns, products, rows);
}
